export const fileTypeExtensions = {
  "excel": "xlsx",
  "CSV": "csv",
  "pdf": "pdf",
  "word": "docx"
};